
























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GdprAgree extends Vue {
  @Prop() private msg!: string;
}
